import React from 'react';
import {connect} from 'react-redux';
import {change, Field} from "redux-form";
import {injectIntl} from "react-intl";

import ExpandSection from "../../Generic/expandSection";
import {toggleSectionOpened} from "../AccountActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {FormCheckBoxField, FormField} from "../FormField";
import {AccessRights} from "../../../schemas/accessRightsModel";
import {store} from "../../../main";

class PingWidgetSection extends React.Component {

  updateCheckBoxField = (input) => {
    store.dispatch(change('newEntity', input.name, !input.value))
  };

  render() {
    const {sectionsOpened, toggleSectionOpened, intl, AR} = this.props;
    const {canEditFields} = this.props.accountPageInfo;

    return (
      <ExpandSection opened={sectionsOpened.includes(ACCOUNT_SECTIONS.pingWidget)}
                     onClick={() => toggleSectionOpened(ACCOUNT_SECTIONS.pingWidget)}
                     title="Ping Widget">
        <div className="acc-container">
          <div className="acc-container__row">
            <div className="acc-block">
              <Field name="usePingWidget" component={FormCheckBoxField}
                     disabled={!canEditFields}
                     labelEnabled={intl.formatMessage({id: "account.pingWidget.usePingWidget"})}
                     labelDisabled={intl.formatMessage({id: "account.pingWidget.usePingWidget"})}
                     doubleMargin={true} onChecked={this.updateCheckBoxField}/>
            </div>
          </div>
          <div className="acc-container__row">
            <div className="acc-block">
              <Field name="dataSignal"
                     component={FormField}
                     label={intl.formatMessage({id: "account.pingWidget.dataSignal"})}
                     disabled={!canEditFields}/>
            </div>
            <div className="acc-block">
              {AR.isSiteAdmin(false) ? (
                <div className="acc-field relative">
                  <Field name="pingPilotSubAccountId"
                         component={FormField}
                         label={"Ping Pilot Sub Account Id"}/>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  const {sectionsOpened, accountPageInfo} = store.accountState;
  return {
    sectionsOpened,
    accountPageInfo,
    AR: AccessRights.get(store),
  };
};

const mapDispatchToProps = {
  toggleSectionOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(PingWidgetSection)
);

